import type { FC } from "react"
import { useRouteLoaderData } from "@remix-run/react"
import type { CapsuleProps } from "~/components/capsules"
import { HeroSection } from "~/components/design-system/organisms/HeroSection"
import type { WithCapsuleHeroFragment } from "~/contentful"
import type { loader as layoutLoader } from "~/routes/_page"

interface Props extends CapsuleProps {
  capsule: WithCapsuleHeroFragment
}

const CapsuleHero: FC<Props> = ({ capsule }) => {
  const layoutData = useRouteLoaderData<typeof layoutLoader>("routes/_page")
  const locationPages = layoutData?.locationPages

  if (!capsule.backgroundImage?.url || !capsule.heading) {
    return null
  }

  return (
    <HeroSection
      backgroundImageUrl={capsule.backgroundImage.url}
      backgroundImageMobileUrl={capsule.backgroundImageMobile?.url ?? undefined}
      backgroundImageAlt={capsule.backgroundImageAlt ?? undefined}
      heading={capsule.heading}
      subHeading={capsule.subHeading ?? undefined}
      ctaText={capsule.ctaText ?? undefined}
      ctaLink={capsule.ctaLink ?? undefined}
      locationPages={locationPages}
      reviewText={capsule.reviewText ?? undefined}
      overlayImageUrl={capsule.overlayImage?.url ?? undefined}
      mobileTextAlignment={
        capsule.mobileTextAlignment as "Left" | "Center" | "Right" | undefined
      }
      hideOverlay={capsule.hideOverlay ?? false}
      textColor={capsule.textColor ?? undefined}
      overlayColor={capsule.overlayColor ?? undefined}
    />
  )
}

export default CapsuleHero
